/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cl_Dialog_IntroInputs */

const en_cl_dialog_intro = /** @type {(inputs: Cl_Dialog_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The language your team writes items and comments in.`)
};

const de_cl_dialog_intro = /** @type {(inputs: Cl_Dialog_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Sprache, in der dein Team Elemente und Kommentare schreibt.`)
};

/**
* | output |
* | --- |
* | "The language your team writes items and comments in." |
*
* @param {Cl_Dialog_IntroInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cl_dialog_intro = /** @type {((inputs?: Cl_Dialog_IntroInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cl_Dialog_IntroInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cl_dialog_intro(inputs)
	return en_cl_dialog_intro(inputs)
});